import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/dev/Dev.js"
import Navigation from "@frog/source/engine/navigating/Navigation.js"
import * as Ribbit from "@frog/source/utility/integration/Ribbit.js"
import * as tilespreadFormats from "@frog/source/models/dev/tilespread-formats.js"

import UnitTemplateSprite from "@frog/source/views/components/UnitTemplateSprite.jsx"

import unitTemplates from "@frog/source/data/unitTemplates.js"
import {tileset} from "@frog/source/data/tilesets.js"
import games from "@frog/source/data/games/index.js"

import "@frog/source/views/dev/DevNavigatorUI.less"

const EIGHT_HOURS = 1000 * 60 * 60 * 8

export class DevSavestatesNavigatorUI {
    render() {
        const backSavestate = JSON.parse(localStorage.getItem("savestate_" + App.game?.slug + "_" + App.game?.chapter.slug + "_" + "back"))
        return (
            <div class="DevSavestateNavigator">
                <SavestateLink localstoredSavestate={backSavestate}/>
                {Object.keys(localStorage).sort().map((key) => {
                    if(key.startsWith("savestate_") == false) return
                    const localstoredSavestate = JSON.parse(localStorage.getItem(key))
                    if(localstoredSavestate == undefined) return
                    if(localstoredSavestate.actionTrace == undefined) return
                    if(localstoredSavestate.name == "back") return

                    return <SavestateLink localstoredSavestate={localstoredSavestate}/>
                })}
            </div>
        )
    }
}
class SavestateLink {
    render() {
        if(this.props.localstoredSavestate == undefined) return
        return (
            <div class="SavestateLink" isShown={this.isShown + ""}>
                <div class="Save" isClicked={this.isSaveClicked + ""} onClick={this.onSaveClick}>{this.isSaveClicked ? "Saved" : "Save?"}</div>
                <div class="Name" onClick={this.onClick}>{this.props.localstoredSavestate.name}</div>
                <input class="Memo" id={this.props.localstoredSavestate.name + "_memo"} type="text"
                    onKeyDown={this.onKey} onKeyUp={this.onKey} onBlur={this.onChange}
                    defaultValue={this.props.localstoredSavestate.memo}/>
            </div>
        )
    }
    get isSaveClicked() {
        return Date.now() < this.lastSaveClick + 2000
    }
    get onSaveClick() {
        return () => {
            this.lastSaveClick = Date.now()
            Dev.saveSavetestToFile(this.props.localstoredSavestate)
        }
    }
    get onClick() {
        if(this.props.localstoredSavestate == undefined) return
        return () => {
            Dev.inProtoMode = false
            Navigation.go("/games/" + this.props.localstoredSavestate.gameSlug + "/chapters/" + this.props.localstoredSavestate.chapterSlug)
            Dev.replaySavestate(this.props.localstoredSavestate)
        }
    }
    get isShown() {
        if(this.props.localstoredSavestate == undefined) return false
        return ((this.props.localstoredSavestate.gameSlug == Navigation.state?.gameSlug
        && this.props.localstoredSavestate.chapterSlug == Navigation.state?.chapterSlug
        && this.props.localstoredSavestate.captureDate >= Date.now() - EIGHT_HOURS)
        || this.props.localstoredSavestate.name == "back")
    }
    get onKey() {
        return (event) => {
            this.props.localstoredSavestate.memo = event.target.value.trim()
            event.stopPropagation()
        }
    }
    get onChange() {
        return (event) => {
            this.props.localstoredSavestate.memo = event.target.value.trim()
            localStorage.setItem(
                "savestate_" + this.props.localstoredSavestate.gameSlug + "_" + this.props.localstoredSavestate.chapterSlug + "_" + this.props.localstoredSavestate.name,
                JSON.stringify(this.props.localstoredSavestate,undefined,4)
            )
        }
    }
}

// TODO: this should probably be in a data file, sim to unittemplates.js
const spotTemplates = [
    {"tag": "spawn"},
    {"tag": "escape"},
    {"tag": "path"},
    {"tag": "goodspawn"},
    {"tag": "badspawn"},
    {"tag": "badspawnspawn", "hasCollision": true},
    {"tag": "wall"},
]
const ENCOUNTER_ASSETS = [
    "rectangle",
    "polygon",
    "vertex",
]
const RIBBIT_ASSETS = [
    {
        "performer": "Title: ",
    },
    {
        "performer": "Banner: ",
        "acts": {
            "success": [],
            "failure": [],
        },
    },
    {
        "performer": "Music: ",
    },
    {
        "performer": "any-unit: ",
        "acts": {
            "enters": [1, 2, 3, 4],
            "exits": [],
            "moves": ["XxY", "spotkey"],
        },
    },
]
export class DevPaletteUI {
    render() {
        if(App.game == undefined) return
        if(Dev.isPaletteShowing() != true) return
        if(Dev.mode == "geography") {
            return (
                <div class="DevNavigatorPane">
                    <input class="Search" id="search-palette" type="text"
                        onKeyDown={this.onKey} onKeyUp={this.onKey}
                        placeholder="Search for an asset"/>
                    <div class="Folder">
                        <div class="Title" onClick={this.onClick("tiles")}>Tiles</div>
                        <div class="Items" isExpanded={Dev.isAssetsFolderExpanded.tiles + ""}>
                            {Object.values(tileset).sort((a,b) => a.drawOrder - b.drawOrder).map((template) => <TileTemplate template={template}/>)}
                        </div>
                    </div>
                    <div class="Folder">
                        <div class="Title" onClick={this.onClick("zones")}>Zones</div>
                        <div class="Items" isExpanded={Dev.isAssetsFolderExpanded.zones + ""}>
                            {ENCOUNTER_ASSETS.map((asset) => <EncounterAsset assetKey={asset}/>)}
                        </div>
                    </div>
                </div>
            )
        } else if(Dev.mode == "scripts") {
            return (
                <div class="DevNavigatorPane">
                    <input class="Search" id="search-palette" type="text"
                        onKeyDown={this.onKey} onKeyUp={this.onKey}
                        placeholder="Search for an asset"/>
                    <div class="Folder">
                        <div class="Title" onClick={this.onClick("scripting")}>Scripting</div>
                        <div class="Items" isExpanded={Dev.isAssetsFolderExpanded.scripting + ""}>
                            {Object.keys(Ribbit.RIBBIT_COMMANDS).map((command) => <RibbitTemplate command={command}/>)}
                        </div>
                    </div>
                    <div class="Folder">
                        <div class="Title" onClick={this.onClick("spots")}>Spots</div>
                        <div class="Items" isExpanded={Dev.isAssetsFolderExpanded.spots + ""}>
                            {spotTemplates.map((template) => <SpotTemplate template={template}/>)}
                        </div>
                    </div>
                </div>
            )
        }
        const displacedJobs = []
        Object.values(unitTemplates).forEach((template) => {
            const keyPath = template.templateKey.split("/")
            if(keyPath.length == 3
            && (keyPath[0] == "jobs" || keyPath[0] == "player")
            && Object.keys(games).includes(keyPath[1])) {
                if(Navigation.state?.gameSlug == undefined
                || keyPath[1] == Navigation.state?.gameSlug) {
                    displacedJobs.push(keyPath[0] + "/" + keyPath[2])
                }
            }
        })
        return (
            <div class="DevNavigatorPane">
                <input class="Search" id="search-palette" type="text"
                    onKeyDown={this.onKey} onKeyUp={this.onKey}
                    placeholder="Search for an asset"/>
                <div class="Folder">
                    <div class="Title" onClick={this.onClick("units")}>Units</div>
                    <div class="Items" isExpanded={Dev.isAssetsFolderExpanded.units + ""}>
                        {Object.values(unitTemplates).map((template) => {
                            if(displacedJobs.includes(template.templateKey)) return
                            const keyPath = template.templateKey.split("/")
                            if(keyPath.length == 3
                            && (keyPath[0] == "jobs" || keyPath[0] == "player")
                            && Object.keys(games).includes(keyPath[1])) {
                                if(Navigation.state?.gameSlug == undefined
                                || keyPath[1] != Navigation.state?.gameSlug) return
                            }
                            return <UnitTemplate template={template}/>
                        })}
                    </div>
                </div>
                <div class="Folder">
                    <div class="Title" onClick={this.onClick("spots")}>Spots</div>
                    <div class="Items" isExpanded={Dev.isAssetsFolderExpanded.spots + ""}>
                        {spotTemplates.map((template) => <SpotTemplate template={template}/>)}
                    </div>
                </div>
            </div>
        )
    }
    get onKey() {
        return (event) => {
            Dev.navigatorSearchQuery = event.target.value.trim()
            event.stopPropagation()
        }
    }
    onClick(objectType) {
        return () => {
            Dev.isAssetsFolderExpanded[objectType] = !Dev.isAssetsFolderExpanded[objectType]
            Dev.storeDevSettings()
        }
    }
}

class EncounterAsset {
    render() {
        return (
            <div class="NavItem" onClick={this.onClick}
                isSelected={this.isSelected}>
                <div class="Name Column">{this.props.assetKey}</div>
            </div>
        )
    }
    get onClick() {
        return () => {
            if(Dev.devSelection.selectedEncounterAsset == this.props.assetKey) {
                Dev.devSelection.selectedEncounterAsset = undefined
            } else {
                Dev.devSelection.selectedEncounterAsset = this.props.assetKey
            }
            Dev.devSelection.selectedTileTemplate = undefined
            Dev.devSelection.selectedSpotTemplate = undefined
            Dev.selectedTemplate = undefined
        }
    }
    get isSelected() {
        return Dev.devSelection.selectedEncounterAsset == this.props.assetKey
    }
}
const WANG_DEMO_INDEX = 1
class TileTemplate {
    render() {
        return (
            <div class="NavItem" onClick={this.onClick}
                isShown={this.isShown + ""}
                isSelected={this.isSelected}>
                <div class="Image Column">
                    <div class="Thumbnail" style={this.imageStyle}/>
                </div>
                <div class="Name Column">{this.props.template.name || this.props.template.key}</div>
                <div class="String Column">{this.props.template.channelKey}</div>
            </div>
        )
    }
    get onClick() {
        return () => {
            if(Dev.devSelection.selectedTileTemplate == this.props.template) {
                Dev.devSelection.selectedTileTemplate = undefined
            } else {
                Dev.devSelection.selectedTileTemplate = this.props.template
            }
            Dev.devSelection.selectedEncounterAsset = undefined
            Dev.devSelection.selectedSpotTemplate = undefined
            Dev.selectedTemplate = undefined
        }
    }
    get isSelected() {
        return Dev.devSelection.selectedTileTemplate == this.props.template
    }
    get isShown() {
        // If there is no search query, then
        // we don't filter anything at all.
        if(isNavigatorSearchEmpty()) {
            return true
        }

        if(this.props.template.key != undefined
        && this.props.template.key.toLowerCase().includes(Dev.navigatorSearchQuery)) {
            return true
        }

        if(this.props.template.name != undefined
        && this.props.template.name.toLowerCase().includes(Dev.navigatorSearchQuery)) {
            return true
        }
        // If it didn't pass any of the above
        // checks, then it should be filtered out!!
        return false
    }
    get imageStyle() {
        const imageStyle = {}
        if(this.props.template.image != undefined) {
            imageStyle["background-image"] = "url(" + this.props.template.image.src + ")"
            if(this.props.template.tilespreadType == "corner-match") {
                imageStyle["background-size"] = "4em"
                imageStyle["background-position-x"] = "-" + tilespreadFormats.wangCornerMatch[WANG_DEMO_INDEX].x + "em"
                imageStyle["background-position-y"] = "-" + tilespreadFormats.wangCornerMatch[WANG_DEMO_INDEX].y + "em"
            }
            if(this.props.template.tilespreadType == "corner-continuous") {
                imageStyle["background-size"] = "4em"
                imageStyle["background-position-x"] = "-" + tilespreadFormats.wangCornerContinuous[WANG_DEMO_INDEX].x + "em"
                imageStyle["background-position-y"] = "-" + tilespreadFormats.wangCornerContinuous[WANG_DEMO_INDEX].y + "em"
            }
            if(this.props.template.tilespreadType == "edge-match") {
                imageStyle["background-size"] = "4em"
                imageStyle["background-position-x"] = "-" + tilespreadFormats.wangEdgeMatch[WANG_DEMO_INDEX].x + "em"
                imageStyle["background-position-y"] = "-" + tilespreadFormats.wangEdgeMatch[WANG_DEMO_INDEX].y + "em"
            }
        }
        if(this.props.template.images != undefined) {
            imageStyle["background-image"] = "url(" + this.props.template.images[WANG_DEMO_INDEX].src + ")"
        }
        if(this.props.template.image == undefined
        && this.props.template.images == undefined
        && this.props.template.tint != undefined) {
            imageStyle["background-color"] = "rgb(" + this.props.template.tint.R + "," + this.props.template.tint.G + "," + this.props.template.tint.B + ")"
        }
        return imageStyle
    }
}
class RibbitTemplate {
    render() {
        const commandFunction = Ribbit.RIBBIT_COMMANDS[this.props.command]
        if(Object.keys(commandFunction).length == 0) {
            const text = this.props.command.toUpperCase()
            return (
                <div class="NavItem" onClick={this.onClick(text)}>
                    <div class="Name Column">{text}</div>
                </div>
            )
        }
        return (
            Object.keys(commandFunction).map((actKey) => {
                const text = this.props.command.toUpperCase() + ": " + actKey.toUpperCase()
                return (
                    <div class="NavItem" onClick={this.onClick(text)}>
                        <div class="Name Column">{text}</div>
                    </div>
                )
            })
        )
    }
    onClick(text) {
        return () => {
            Dev.devSelection.selectedSceneStep.body = Dev.devSelection.selectedSceneStep.body + " " + text
        }
    }
    get isShown() {
        // If there is no search query, then
        // we don't filter anything at all.
        if(isNavigatorSearchEmpty()) {
            return true
        }

        if(this.props.command != undefined
        && this.props.command.toLowerCase().includes(Dev.navigatorSearchQuery)) {
            return true
        }

        if(Ribbit.RIBBIT_COMMANDS[this.props.command] != undefined
        && Object.keys(Ribbit.RIBBIT_COMMANDS[this.props.command]).length > 0
        && Object.keys(Ribbit.RIBBIT_COMMANDS[this.props.command]).find((actKey) => actKey.toLowerCase().includes(Dev.navigatorSearchQuery)) != undefined) {
            return true
        }
        // If it didn't pass any of the above
        // checks, then it should be filtered out!!
        return false
    }
}
class SpotTemplate {
    render() {
        return (
            <div class="NavItem" onClick={this.onClick}
                style={this.style}
                isShown={this.isShown + ""}
                isSelected={this.isSelected}>
                <div class="Name Column">{this.props.template.tag}</div>
            </div>
        )
    }
    get style() {
        if(Dev.tagColors[this.props.template.tag] != undefined) {
            return {"color": Dev.tagColors[this.props.template.tag]}
        }
        return {}
    }
    get onClick() {
        return () => {
            if(Dev.devSelection.selectedSpotTemplate == this.props.template) {
                Dev.devSelection.selectedSpotTemplate = undefined
            } else {
                Dev.devSelection.selectedSpotTemplate = this.props.template
            }
            Dev.devSelection.selectedEncounterAsset = undefined
            Dev.devSelection.selectedTileTemplate = undefined
            Dev.selectedTemplate = undefined
        }
    }
    get isSelected() {
        return Dev.devSelection.selectedSpotTemplate == this.props.template
    }
    get isShown() {
        // If there is no search query, then
        // we don't filter anything at all.
        if(isNavigatorSearchEmpty()) {
            return true
        }

        if(this.props.template.tag != undefined
        && this.props.template.tag.toLowerCase().includes(Dev.navigatorSearchQuery)) {
            return true
        }
        // If it didn't pass any of the above
        // checks, then it should be filtered out!!
        return false
    }
}
class UnitTemplate {
    render() {
        return (
            <div class="NavItem" onClick={this.onClick}
                isSelected={this.isSelected} isShown={this.isShown + ""}>
                <div class="Image Column">
                    <UnitTemplateSprite unitTemplate={this.props.template}/>
                </div>
                <div class="Name Column">{this.props.template.templateKey}</div>
            </div>
        )
    }
    get onClick() {
        return () => {
            if(Dev.selectedTemplate == this.props.template) {
                Dev.selectedTemplate = undefined
            } else {
                Dev.selectedTemplate = this.props.template
            }
            Dev.devSelection.selectedEncounterAsset = undefined
            Dev.devSelection.selectedTileTemplate = undefined
            Dev.devSelection.selectedSpotTemplate = undefined
        }
    }
    get isSelected() {
        return Dev.selectedTemplate == this.props.template
    }
    get isShown() {
        // If there is no search query, then
        // we don't filter anything at all.
        if(isNavigatorSearchEmpty()) {
            return true
        }

        if(this.props.template.templateKey != undefined
        && this.props.template.templateKey.toLowerCase().includes(Dev.navigatorSearchQuery)) {
            return true
        }
        if(this.props.template.jobKey != undefined
        && this.props.template.jobKey.toLowerCase().includes(Dev.navigatorSearchQuery)) {
            return true
        }
        if(this.props.template.randomJobKey != undefined
        && this.props.template.randomJobKey.toLowerCase().includes(Dev.navigatorSearchQuery)) {
            return true
        }
        // If it didn't pass any of the above
        // checks, then it should be filtered out!!
        return false
    }
}

export class DevNavigatorUI {
    render() {
        return (
            <div class="DevNavigatorPane">
                <input class="Search" id="search-palette" type="text"
                    onKeyDown={this.onKey} onKeyUp={this.onKey}
                    placeholder="Search for a chapter"/>
                <div class="Games">
                    {Object.values(games).map((game) => {
                        return <GameLink game={game}/>
                    })}
                </div>
            </div>
        )
    }
    get onKey() {
        return (event) => {
            Dev.navigatorSearchQuery = event.target.value.trim().toLowerCase()
            event.stopPropagation()
        }
    }
}
function isNavigatorSearchEmpty() {
    return Dev.navigatorSearchQuery == ""
        || Dev.navigatorSearchQuery == undefined
}
class GameLink {
    constructor() {
        this.isExpanded = true
    }
    render() {
        if(this.isSelected == true
        || isNavigatorSearchEmpty() == false) {
            return (
                <div class="GameHierarchy Folder">
                    <div class="Title" onClick={this.onClick}
                        isSelected={this.isSelected} isShown={this.isShown + ""}>
                        {this.props.game.slug}
                    </div>
                    <div class="Items" isExpanded={this.isExpanded + ""}>
                        {Object.values(this.props.game.chapters).map((chapter) => {
                            return <ChapterLink game={this.props.game} chapter={chapter}/>
                        })}
                    </div>
                </div>
            )
        } else {
            return (
                <div class="GameHierarchy Folder">
                    <div class="Title" onClick={this.onClick}
                        isSelected={this.isSelected} isShown={this.isShown + ""}>
                        {this.props.game.slug}
                    </div>
                </div>
            )
        }
    }
    get onClick() {
        return () => {
            if(this.isSelected == true) this.isExpanded = !this.isExpanded
            Navigation.go("/games/"+this.props.game.slug)
        }
    }
    get isSelected() {
        return Navigation.state?.gameSlug == this.props.game.slug
            || Navigation.state?.gameSlug == undefined
    }
    get isShown() {
        // If there is no search query, then
        // we don't filter anything at all.
        if(isNavigatorSearchEmpty()) {
            return true
        }

        if(this.props.game.slug != undefined
        && this.props.game.slug.toLowerCase().includes(Dev.navigatorSearchQuery)) {
            return true
        }

        if(this.props.game.chapters != undefined) {
            return Object.values(this.props.game.chapters).some((chapter) => {
                return isChapterInSearch(chapter)
            })
        }

        // If it didn't pass any of the above
        // checks, then it should be filtered out!!
        return false
    }
}
class ChapterLink {
    constructor() {
        this.isExpanded = true
    }
    render() {
        if(this.isSelected == true
        || isNavigatorSearchEmpty() == false) {
            return (
                <div class="ChapterHierarchy Folder">
                    <div class="Title" onClick={this.onClick} style="padding-left: 1em"
                        isSelected={this.isSelected} isShown={this.isShown + ""}>
                        {this.props.chapter.slug}
                    </div>
                    <div class="Items" isExpanded={this.isExpanded + ""}>
                        {Object.values(this.props.chapter.stage.world.zones).map((encounter) => {
                            return <EncounterLink game={this.props.game} chapter={this.props.chapter} encounter={encounter}/>
                        })}
                    </div>
                </div>
            )
        } else {
            return (
                <div class="ChapterHierarchy Folder">
                    <div class="Title" onClick={this.onClick} style="padding-left: 1em"
                        isSelected={this.isSelected} isShown={this.isShown + ""}>
                        {this.props.chapter.slug}
                    </div>
                </div>
            )
        }
    }
    get onClick() {
        return () => {
            if(this.isSelected == true) this.isExpanded = !this.isExpanded
            Navigation.go("/games/" + this.props.game.slug + "/chapters/" + this.props.chapter.slug)
        }
    }
    get isSelected() {
        return Navigation.state?.chapterSlug == this.props.chapter.slug
            || Navigation.state?.chapterSlug == undefined
    }
    get isShown() {
        // If there is no search query, then
        // we don't filter anything at all.
        if(isNavigatorSearchEmpty() != true) {
            return isChapterInSearch(this.props.chapter)
            // return true // shown by default?
        }

        return true
    }
}
function isChapterInSearch(chapter) {
    if(chapter.slug != undefined
    && chapter.slug.toLowerCase().includes(Dev.navigatorSearchQuery)) {
        return true
    }

    if(chapter.stage.world.zones != undefined) {
        return Object.values(chapter.stage.world.zones).some((encounter) => {
            return isEncounterInSearch(encounter)
        })
    }
}
class EncounterLink {
    render() {
        return (
            <div class="NavItem"
                onClick={this.onClick}
                onPointerOver={this.onPointerOver}
                onPointerOut={this.onPointerOut}
                style="padding-left: 2em"
                isSelected={this.isSelected}
                isShown={this.isShown + ""}>
                <div class="Column">{this.props.encounter.slug}</div>
                <div class="Column">{this.props.encounter.name}</div>
            </div>
        )
    }
    get onClick() {
        return () => {
            Navigation.go("/games/" + this.props.game.slug + "/chapters/" + this.props.chapter.slug + "/encounters/" + this.props.encounter.slug)
        }
    }
    get isSelected() {
        return (
            Navigation.state?.screen == "ChapterScreen"
            && Navigation.state?.chapterSlug == this.props.chapter.slug
            && App.game.chapter.stage.currentEncounterKey == this.props.encounter.slug
        )
    }
    get isShown() {
        // If there is no search query, then
        // we don't filter anything at all.
        if(isNavigatorSearchEmpty() != true) {
            return isEncounterInSearch(this.props.encounter)
        }

        return Navigation.state?.chapterSlug == this.props.chapter.slug
    }
    get onPointerOver() {
        return () => {
            Dev.devSelection.listHoveredEncounterKey = this.props.encounter.slug
        }
    }
    get onPointerOut() {
        return () => {
            Dev.devSelection.listHoveredEncounterKey = undefined
        }
    }
}
function isEncounterInSearch(encounter) {
    if(encounter.slug != undefined
    && (encounter.slug + "").toLowerCase().includes(Dev.navigatorSearchQuery)) {
        return true
    }

    if(encounter.name != undefined
    && encounter.name.toLowerCase().includes(Dev.navigatorSearchQuery)) {
        return true
    }
    // If it didn't pass any of the above
    // checks, then it should be filtered out!!
    return false
}
